import { API_URL } from '@/consts';

import { LoginData } from '../types/claimPanel';
import { useMutation } from '@tanstack/react-query';

export const getClaimPanel = (data: LoginData, hash: string) => {
  return fetch(`${API_URL}/api/self-service/claim-panel`, {
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      case_id: data.caseId,
      pesel: data.pesel,
      hash: hash,
    }),
  });
};

export const useClaimPanelMutation = () => {
  return useMutation({
    mutationFn: async ({ data, hash }: { data: LoginData; hash: string }) =>
      getClaimPanel(data, hash),
  });
};

export const getClaimPanelInfo = (data: LoginData) => {
  return fetch(`${API_URL}/api/self-service/claim-panel-info`, {
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      case_id: data.caseId,
      pesel: data.pesel,
    }),
  });
};

export const useClaimPanelInfoMutation = () => {
  return useMutation({
    mutationFn: async ({ data }: { data: LoginData }) =>
      getClaimPanelInfo(data),
  });
};
